import { useSelector } from 'react-redux';
import { useCallback } from 'react';

type UseVendors = {
  vendors: any;
  vendorEndpoints: any;
  getVendorByID(id: number): any;
};

export function useVendors(): UseVendors {
  const vendors = useSelector((s: any) => s.entities.vendors);
  const vendorEndpoints = useSelector((s: any) => s.entities.vendorEndpoints);

  const getVendorByID = useCallback((id: number) => (id ? vendors[id] : null), [vendors]);

  return {
    vendors,
    getVendorByID,
    vendorEndpoints,
  };
}
